





























































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { HTデータ取込対象型, ハンディPC発注取得依頼型, ハンディPC発注取得結果一覧型, ハンディPC発注取得結果型 } from '@/type/purchaseorder/item';
import { ハンディPC発注取込レコード型, ハンディPC発注取込型, ハンディPC発注取込結果型, 発注未確定重複レコード型 } from '@/type/purchaseorder/item';
import { 採用区分型, ハンディPC発注取込区分, ハンディPC発注取込結果区分 } from '@/type/purchaseorder/types';
import { 発注重複表示区分 } from '@/type/purchaseorder/types';
import { 表示用日付 } from '@/type/purchaseorder/order-function';
import api from '@/infrastructure/api/api';
import { progress } from '@/script/progress';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import DuplicateWarningDialog from '@/views/purchaseorder/DuplicateWarningDialog.vue';

@Component({
  filters: {
    採用区分を表示(採用区分: 採用区分型): string | null {
      return (採用区分 === 採用区分型.採用済) ? '採用' : '';
    },
    表示用日付を取得(日付: string): string {
      return 表示用日付(日付);
    },
  },
  components: {
    NormalDialog,
    DuplicateWarningDialog,
  },
})

export default class HandyImportDialog extends Vue {
  private ハンディPC発注取得条件: ハンディPC発注取得依頼型 = this.検索条件初期値を取得();
  private ハンディPC発注取込対象リスト: ハンディPC発注取得結果型[] = [];
  private 発注重複商品リスト: 発注未確定重複レコード型[] = [];

  private 警告画面表示: boolean = false;
  private 警告画面表示モード: string = 発注重複表示区分.発注未確定登録;

  @Prop({default: false})
  private modal!: boolean;

  @Prop({ default: []})
  private deviceList!: HTデータ取込対象型[];

  private get 表示件数を取得() {
    return this.ハンディPC発注取込対象リスト.length;
  }

  private async 確定するハンドラ() {
      await progress(this.確定する);
  }

  private async 確定する(): Promise<void> {
    if (this.ハンディPC発注取込対象リスト.length === 0) {
      this.$emit('show-alert', '取込対象の発注がありません');
      return;
    }

    const 取込対象リスト: ハンディPC発注取込レコード型[] = this.ハンディPC発注取込対象リスト
      .map((取得対象: ハンディPC発注取得結果型) => {
        return {
          ハンディPC発注シーケンス番号: 取得対象.ハンディPC発注シーケンス番号,
          更新バージョン: 取得対象.更新バージョン,
        };
      });

    const ハンディPC発注取込依頼: ハンディPC発注取込型 = {
      ハンディPC発注取込方法区分: ハンディPC発注取込区分.重複確認して取り込む,
      ハンディPC発注取込リスト: 取込対象リスト,
    };

    await api.ハンディPC発注を取り込む(ハンディPC発注取込依頼)
    .then((response: ハンディPC発注取込結果型) => {
      if (response.ハンディPC発注取込結果区分 === ハンディPC発注取込結果区分.重複登録あり) {
        this.発注重複商品リスト = response.発注未確定重複リスト;
        this.警告画面表示 = true;
      } else {
        this.$modal.hide('HTデータ取込画面');
        this.$emit('finish-handy-import');
      }

    }).catch((error: any) => {
      this.$emit('show-alert', error.data.message);
    });
  }

  private async 重複ありで確定するハンドラ() {
      await progress(this.重複ありで確定する);
  }

  private async 重複ありで確定する(): Promise<void> {
    this.警告画面表示 = false;

    if (this.ハンディPC発注取込対象リスト.length === 0) {
      this.$emit('show-alert', '取込対象の発注がありません');
      return;
    }

    const 取込対象リスト: ハンディPC発注取込レコード型[] = this.ハンディPC発注取込対象リスト
      .map((取得対象: ハンディPC発注取得結果型) => {
        return {
          ハンディPC発注シーケンス番号: 取得対象.ハンディPC発注シーケンス番号,
          更新バージョン: 取得対象.更新バージョン,
        };
      });

    const ハンディPC発注取込依頼: ハンディPC発注取込型 = {
      ハンディPC発注取込方法区分: ハンディPC発注取込区分.取り込む,
      ハンディPC発注取込リスト: 取込対象リスト,
    };

    await api.ハンディPC発注を取り込む(ハンディPC発注取込依頼)
    .then((response: ハンディPC発注取込結果型) => {
      this.$modal.hide('HTデータ取込画面');
      this.$emit('finish-handy-import');

    }).catch((error: any) => {
      this.$emit('show-alert', error.data.message);
    });
  }

  private 確認画面に戻る() {
    this.警告画面表示 = false;
    this.発注重複商品リスト = [];
  }

  private 戻る() {
    this.警告画面表示 = false;
    this.発注重複商品リスト = [];
    this.$modal.hide('HTデータ取込画面');
    this.$emit('finish-handy-import');
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.ハンディPC発注取込対象リスト = [];
      this.ハンディPC発注取得条件 = this.検索条件初期値を取得();
      this.警告画面表示 = false;
      this.発注重複商品リスト = [];
      this.$modal.show('HTデータ取込画面');
    }
  }

  private 検索条件初期値を取得(): ハンディPC発注取得依頼型 {
    return {
      機械番号: '',
    };
  }

  private async 検索するハンドラ() {
      await progress(this.検索する);
  }

  private async 検索する(): Promise<void> {
    await api.ハンディPC発注一覧を取得する(this.ハンディPC発注取得条件)
    .then((response: ハンディPC発注取得結果一覧型) => {
      this.ハンディPC発注取込対象リスト = response.ハンディPC発注取得結果レコードリスト;

      if (this.ハンディPC発注取込対象リスト.length === 0) {
        this.$emit('show-alert', '取込対象の発注が見つかりませんでした');
      }

    }).catch((error: any) => {
      this.$emit('show-alert', error.data.message);
    });
  }
}

